<template>
  <div class="small">
    <bar-chart v-if="datacollection" :chart-data="datacollection" :options="options"></bar-chart>
    <!-- <button @click="fillData()">Update</button> -->
  </div>
</template>

<script>
  import BarChart from './BarChart.js'

  export default {
    components: {
      BarChart
    },
    // name: 'randomlinechart',
    props: [
      'data'
    ],
    data () {
      return {
        datacollection: null,
        options: {
          legend: {
            display: false
          }
        }
      }
    },
    mounted () {
      this.fillData()
      // console.log("=====> " + JSON.stringify(this.data))
    },
    methods: {
      fillData () {
        let tmpdatacollection = null
        if (this.data) {
          tmpdatacollection = {
            labels: Object.keys(this.data),
            backgroundColor: ['grey'],
            datasets: [
              {
                label: 'Obrat',
                // backgroundColor: '#f87979',
                backgroundColor: ['gold', 'silver', '#ac7c42', '#424c53'],
                data: Object.values(this.data)
              }, 
            ]
          }
        }
        this.datacollection = tmpdatacollection
      },
      // fillData () {
      //   this.datacollection = {
      //     labels: ['A', 'B', 'C', 'D'],
      //     backgroundColor: ['grey'],
      //     datasets: [
      //       {
      //         label: 'Obrat',
      //         // backgroundColor: '#f87979',
      //         backgroundColor: ['gold', 'silver', '#ac7c42', '#424c53'],
      //         data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()]
      //       }, 
      //     ]
      //   }
      // },
      // getRandomInt () {
      //   return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      // }
    },
    watch: {
      data () {
        // console.log("watch BarChart => data changed")
        // console.log("=====> " + JSON.stringify(this.data))
        this.fillData()
      }
    } 
  }
</script>

<style>
  .small {
    max-width: 600px;
    margin:  15px auto;
    padding: 15px;
  }
</style>